<h2 mat-dialog-title>{{ 'nav.dialog.login.title' | translate }}</h2>
<mat-dialog-content class="mat-typography">
    <div>
        <mat-form-field>
            <mat-label>{{ 'nav.dialog.login.username' | translate }}</mat-label>
            <input matInput class="login-logout-input" [(ngModel)]="credentials.username">
        </mat-form-field>
    </div>
    <div>
        <mat-form-field>
            <mat-label>{{ 'nav.dialog.login.pwd' | translate }}</mat-label>
            <input matInput type="password" [(ngModel)]="credentials.password">
        </mat-form-field>
    </div>
    <p *ngIf="error_cred" class="wrong-att">{{ 'nav.dialog.login.wrong' | translate }}</p>
    <div class="forgot-pwd">
        <span (click)="showForgotPwdInfo = !showForgotPwdInfo" class="forgot">{{ 'nav.dialog.login.forgot' | translate }}</span>
        <span *ngIf="showForgotPwdInfo" class="contact">{{ 'nav.dialog.login.contact' | translate }}</span>
    </div>
</mat-dialog-content>

<div class="login-logout-btns">
    <button mat-button [mat-dialog-close]="true">{{ 'nav.dialog.login.cancel' | translate }}</button>
    <button mat-button (click)="loginRequest()" cdkFocusInitial class="login-logout">{{ 'nav.dialog.login.login' | translate }}</button>
</div>
